import { Expansion } from '../../../shared/gameConfig/expansion';
import { isExpansionFeatureAllowed, isRaidFeatureAllowed, isSeasonFeatureAllowed } from './expansionFeatureAccess';

export const MIN_FIND_VIDEOS_BY_SPEC_EXPANSION = Expansion.Midnight;

export function isFindVideosBySpecExpansionAllowed(expansionId: number | null | undefined) {
  return isExpansionFeatureAllowed(expansionId, MIN_FIND_VIDEOS_BY_SPEC_EXPANSION);
}

export function isFindVideosBySpecRaidAllowed(raidSlug: string | null | undefined) {
  return isRaidFeatureAllowed(raidSlug, MIN_FIND_VIDEOS_BY_SPEC_EXPANSION);
}

export function isFindVideosBySpecSeasonAllowed(seasonSlug: string | null | undefined) {
  return isSeasonFeatureAllowed(seasonSlug, MIN_FIND_VIDEOS_BY_SPEC_EXPANSION);
}
